import * as angular from "angular";
import {VehicleStatusChangeReasonSettingsEntity} from "../models/vehicle-status-change-reason-settings.model";

export class VehicleStatusChangeReasonsDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  createVehicleStatusChangeReason(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-vehicle-status-change-reason-dialog.html').default,
      controller: function ($scope) {
        $scope.header = 'Create Vehicle Status Change Reason';
        $scope.action = 'Create';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.vehicleStatusChangeReason = {}

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({vehicleStatusChangeReason: $scope.vehicleStatusChangeReason});
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editVehicleStatusChangeReason(event, vehicleStatusChangeReasonToEdit: VehicleStatusChangeReasonSettingsEntity) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-vehicle-status-change-reason-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Vehicle Status Change Reason';
        $scope.action = 'Edit';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.vehicleStatusChangeReason = vehicleStatusChangeReasonToEdit

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({vehicleStatusChangeReason: $scope.vehicleStatusChangeReason});
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }
}

angular
  .module('bringoz.admin.site-preferences')
  .service('vehicleStatusChangeReasonsDialogsService', VehicleStatusChangeReasonsDialogsService);
